'use client'

import { useState } from 'react'
import { ChevronDown } from 'lucide-react'

/** Past this many characters of plain text, the body starts collapsed. */
const COLLAPSE_THRESHOLD = 600

/** Sanitized HTML from renderDescription(), plus its plain-text length. */
export type RenderedDescription = { html: string; textLength: number }

export function EventDescription({ html, textLength }: RenderedDescription) {
  const [expanded, setExpanded] = useState(false)

  if (!html) return null

  const collapsible = textLength > COLLAPSE_THRESHOLD
  const collapsed = collapsible && !expanded

  return (
    <div>
      <div className="relative">
        <div
          className={`event-description text-sm leading-relaxed text-muted-foreground ${
            collapsed ? 'max-h-72 overflow-hidden' : ''
          }`}
          dangerouslySetInnerHTML={{ __html: html }}
        />
        {collapsed && (
          <div className="pointer-events-none absolute inset-x-0 bottom-0 h-24 bg-gradient-to-t from-background to-transparent" />
        )}
      </div>

      {collapsible && (
        <button
          type="button"
          onClick={() => setExpanded((v) => !v)}
          aria-expanded={expanded}
          className="mt-3 inline-flex cursor-pointer items-center gap-1.5 rounded-lg border border-border bg-secondary/40 px-3 py-1.5 text-xs font-medium text-muted-foreground outline-none transition-colors hover:bg-white/5 hover:text-foreground focus-visible:ring-2 focus-visible:ring-primary/70"
        >
          {expanded ? 'Show less' : 'Read more'}
          <ChevronDown
            size={14}
            className={`transition-transform duration-200 ${expanded ? 'rotate-180' : ''}`}
          />
        </button>
      )}
    </div>
  )
}
